import { motion } from 'framer-motion';
import { type ComponentPropsWithoutRef } from 'react';

import { rotate } from '@/lib/framer-motion/animation-framer-motion';
import { cn } from '@/lib/tw-merge/cn';

type ParagraphProps = ComponentPropsWithoutRef<'p'>;

export const Loader = () => {
  return (
    <div className="three-body">
      {Array.from({ length: 3 }, (_, index) => (
        <div className="three-body__dot" key={index} />
      ))}
    </div>
  );
};

export const AnimatedPlaceholder = ({ className, ...rest }: ParagraphProps) => {
  return (
    <p
      className={cn(
        `animate-pulse rounded-[4px] bg-gradient-to-r from-[#ca9a8987] ${className}`
      )}
      {...rest}
    >
      &nbsp;
    </p>
  );
};
export const AnimatedPlaceholderForTable = ({
  className,
  cellNumber = 5,
}: {
  className?: string;
  cellNumber?: number;
} = {}) => {
  return (
    <tr
      className={cn(
        `animate-pulse rounded-[4px] bg-gradient-to-r from-[#ca9a8987] ${className}`
      )}
    >
      {Array.from({ length: cellNumber }, (_, index) => (
        <td key={index}>&nbsp;</td>
      ))}
    </tr>
  );
};
export const Spinner = ({ className }: ParagraphProps) => (
  <motion.p
    variants={rotate as any}
    animate="show"
    className={cn(
      `mx-auto flex h-[20px] w-[20px] rounded-[50%] border-[3px] border-primary border-b-[transparent] ${className}`
    )}
  />
);
